import "./menuBar.scss";

import NotificationBadge from "../notificationBadge/NotificationBadge";

import { t } from "i18next";
import { listMenu } from "./data/listMenu";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useGlobalState } from "../../utils/state";
import { isEmpty } from "../../utils/validation";

const MenuBar = () => {
  const navigate = useNavigate();
  //const { id_association } = useParams();
  const [searchParams] = useSearchParams();
  //const adminAssociation = searchParams.get("admin");
  const [selectedIdBottomBar] = useGlobalState("selectedIdBottomBar");
  const [admin] = useGlobalState("admin");

  return (
    <div className="menu-bar-container">
      <div className="menu-bar-wrapper">
        <div className="logo" onClick={() => navigate("/")}>
          <img src="/write_logo.svg" alt="volunteer" />
        </div>

        <div className="primary-menu">
          <hr />
          {listMenu.map((item) => {
            if (item.id === 2 && !admin) {
              return null;
            } else {
              return (
                <div key={item.id}>
                  {item.id === 2 ? <hr /> : null}
                  <SingleItemMenu
                    id={item.id}
                    name={item.name}
                    icon={item.icon}
                    path={item.path}
                    selected={item.id === selectedIdBottomBar}
                    //idAssociation={id_association ?? adminAssociation} NON PIù RICHIESTO ATTUALMENTE
                    subPages={item.id === 2 ? item.subPages : null}
                  />
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

const SingleItemMenu = ({
  id,
  name,
  icon,
  path,
  selected,
  idAssociation,
  subPages,
}) => {
  const navigate = useNavigate();
  const [numberNotifications] = useGlobalState("numberNotifications");

  return (
    <>
      <div
        className="single-menu-item"
        onClick={() => navigate(path)}
        style={
          selected
            ? {
                color: "#03626E",
                backgroundColor: "rgba(65, 144, 163,0.3)",
              }
            : null
        }
      >
        <div>{icon}</div>
        <span>{name}</span>
        {id === 5 ? (
          <NotificationBadge
            numberNotifications={numberNotifications}
            position="absolute"
            right={50}
          />
        ) : null}
      </div>
      {!isEmpty(idAssociation) && !isEmpty(subPages) ? (
        <div className="list-sub-pages">
          <ul>
            {subPages.map((item) => (
              <li key={item.id}>
                <span
                  onClick={() =>
                    navigate(
                      item.path.replace("{{id_association}}", idAssociation)
                    )
                  }
                >
                  {item.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
};

export default MenuBar;
